import { Typography } from '@material-ui/core'
import React from 'react'
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(theme => ({
  wrap: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 0, 2),
  },
  posterWrap: {
    width: 64,
    height: 92,
    borderRadius: 10,
    overflow: 'hidden',
    flexShrink: 0,
    background: '#f2f0ec',
    boxShadow: '0 2px 8px rgba(16,16,16,0.08)'
  },
  poster: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  },
  title: {
    fontSize: '18px',
    fontWeight: 800,
    color: '#161616',
    textTransform: 'capitalize',
    lineHeight: 1.25,
    wordBreak: 'break-word'
  },
}));

const MovieInfoMobile = (props) => {
  const classes = useStyles(props);

  const{movie,selectedTime} = props
  return (
    <div className={classes.wrap}>
      {!selectedTime && (
        <div className={classes.posterWrap}>
          <img src={movie.image} alt='movie-poster' className={classes.poster}/>
        </div>
      )}
      <Typography className={classes.title}>{movie.title}</Typography>
    </div>
  )
}

export default MovieInfoMobile
